package com.iregained.site.components.sections.news.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.JustifyContent

val PressKitContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().backgroundColor(Colors.White)
}

val PressKitGridStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1200.px).gap(60.px)
}

// --- LEFT COLUMN: BOILERPLATE & CONTACT ---
val BoilerplateColumnStyle = CssStyle.base {
    Modifier.fillMaxWidth()
}

val BoilerplateTitleStyle = CssStyle.base {
    Modifier.color(Colors.DarkSlateGray).fontSize(1.5.cssRem).fontWeight(FontWeight.Bold).margin(bottom = 16.px)
}

val BoilerplateTextStyle = CssStyle.base {
    Modifier.color(Colors.Gray).fontSize(1.05.cssRem).lineHeight(1.6).margin(bottom = 32.px)
}

val MediaContactBoxStyle = CssStyle.base {
    Modifier.fillMaxWidth().padding(24.px).backgroundColor(colorMode.toSitePalette().custom.lightGray)
        .borderRadius(12.px).border(1.px, LineStyle.Solid, Colors.LightGray)
}

val MediaContactLabelStyle = CssStyle.base {
    Modifier.color(Colors.DarkSlateGray).fontSize(0.9.cssRem).fontWeight(FontWeight.Bold)
        .textTransform(TextTransform.Uppercase).letterSpacing(1.px).margin(bottom = 8.px)
}

val MediaContactLinkStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().brand.primary).fontSize(1.25.cssRem).fontWeight(FontWeight.SemiBold)
        .textDecorationLine(TextDecorationLine.None)
}

// --- RIGHT COLUMN: DOWNLOADABLE ASSETS ---
val AssetListColumnStyle = CssStyle.base {
    Modifier.fillMaxWidth().display(DisplayStyle.Flex).flexDirection(FlexDirection.Column).gap(16.px)
}

val AssetDownloadCardStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().padding(24.px).backgroundColor(Colors.White).borderRadius(12.px)
            .border(1.px, LineStyle.Solid, Colors.LightGray).display(DisplayStyle.Flex).alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.SpaceBetween).cursor(Cursor.Pointer)
            .textDecorationLine(TextDecorationLine.None)
            .transition(Transition.of("transform", 200.ms), Transition.of("box-shadow", 200.ms))
    }
    hover {
        Modifier.transform { translateY((-4).px) }.boxShadow(0.px, 12.px, 24.px, color = Colors.Black.copy(alpha = 5))
            .border(1.px, LineStyle.Solid, colorMode.toSitePalette().brand.primary)
    }
}

val AssetIconAndTextStyle = CssStyle.base {
    Modifier.display(DisplayStyle.Flex).alignItems(AlignItems.Center).gap(16.px)
}

val AssetIconStyle = CssStyle.base {
    Modifier.size(32.px)
}

val AssetTitleStyle = CssStyle.base {
    Modifier.color(Colors.DarkSlateGray).fontSize(1.125.cssRem).fontWeight(FontWeight.SemiBold)
}

val AssetDescStyle = CssStyle.base {
    Modifier.color(Colors.Gray).fontSize(0.9.cssRem)
}

val DownloadArrowStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().brand.primary).fontSize(1.5.cssRem).fontWeight(FontWeight.Bold)
}